import api from '@/api/Api'
import Model from '@models/model/model'

export const state = {
  models: [],
  modelFolder: [],
  userModels: [],
  communityModel: [],
  submitedCommunityModel: [],
  preTrainedModel: [],
  router: [
    {
      text: 'Root',
      disabled: true,
      id: ''
    }
  ],
  folders: [],
  envs: []
}

export const getters = {
  router (state) {
    return state.router
  },
  folders (state) {
    return state.folders
  },
  modelFolder (state) {
    return state.modelFolder
  },
  models (state) {
    return state.models
  },
  userModels (state) {
    return state.userModels
  },
  communityModel (state) {
    return state.communityModel
  },
  submitedCommunityModel (state) {
    return state.submitedCommunityModel
  },
  preTrainedModel (state) {
    return state.preTrainedModel
  },
  envs (state) {
    return state.envs
  }
}

export const mutations = {
  SET_ROUTER (state, newValue) {
    state.router = newValue
  },
  SET_FOLDER (state, newValue) {
    state.folders = newValue
  },
  SET_MODELS_FOLDER (state, newValue) {
    state.modelFolder = newValue
  },
  UPDATE_MODELS_FOLDER (state, newValue) {
    state.modelFolder = state.modelFolder.concat(newValue)
  },
  SET_MODELS (state, newValue) {
    state.models = newValue
  },
  SET_USERMODELS (state, newValue) {
    state.userModels = newValue
  },
  SET_COMMUNITY_MODEL (state, newValue) {
    state.communityModel = newValue
  },
  SET_SUBMITED_COMMUNITY_MODEL (state, newValue) {
    state.submitedCommunityModel = newValue
  },
  SET_PRE_TRAINED_MODEL (state, newValue) {
    state.preTrainedModel = newValue
  },
  SET_ENVS (state, newValue) {
    state.envs = newValue
  }
}
export const actions = {
  accurateReport ({ commit, dispatch, state }, form) {
    return api.sendAccurateReport(form).then((response) => {
      return response
    })
  },
  shared (payload) {
    return api.getSharedModels(payload).then((response) => {
      return response
    })
  },
  getCommunity ({ commit, dispatch, state }) {
    return api.getCommunityModels().then((response) => {
      commit('SET_COMMUNITY_MODEL', response.data.data)
      return response
    })
  },
  getSubmittedCommunity ({ commit, dispatch, state }) {
    return api.getSubmittedCommunity().then((response) => {
      commit('SET_SUBMITED_COMMUNITY_MODEL', response.data.data)
      return response
    })
  },
  removeModel ({ commit, dispatch, state }, id) {
    return api.removeModel(id).then((response) => {
      return response
    })
  },
  makeCopy ({ commit, dispatch, state }, form) {
    return api.makeCopy(form).then((response) => {
      dispatch('fetchModel', form.workspaceId)
      return response
    })
  },
  editModel ({ commit, state }, form) {
    return api.updateModel(form)
  },
  updateModel ({ commit, state }, form) {
    return api.updateModel(form)
  },
  removeSharedModel ({ commit, state }, form) {
    return api.removeShare(form)
  },
  moveTo ({ commit, state }, form) {
    return api.moveToModelFolder(form)
  },
  renameFolder ({ commit, state }, form) {
    return api.onRenameModelFolder(form).then((response) => {
      return response
    })
  },
  selectFolder ({ commit, state }, form) {
    if (form.reset) {
      form.page = 1
    }
    return api.getDataModelFolder(form).then((response) => {
      const models = response.data.data.models.data.map(val => new Model(val))
      const folders = response.data.data.folders
      if (form.reset) {
        commit('SET_MODELS_FOLDER', models)
        commit('SET_FOLDER', folders)
      } else {
        commit('UPDATE_MODELS_FOLDER', models)
        commit('SET_FOLDER', folders)
      }
      return models
    })
  },
  getMiniFolder ({ commit, state }, form) {
    return api.getDataModelMiniFolder(form).then((response) => {
      // if (!form.isNotChange) {
      //   let models = response.data.data.models.map(val => new Model(val))
      //   commit('SET_MODELS_FOLDER', models)
      //   commit('SET_FOLDER', response.data.data.folders)
      // }
      return response.data.data
    })
  },
  copyToWorkspace ({ commit, state }, form) {
    return api.copyModelTo(form).then((response) => {
      return response
    })
  },
  getFolder ({ commit, state }, form) {
    return api.getDataModelFolder(form).then((response) => {
      if (!form.isNotChange) {
        let models = response.data.data.models.data.map(val => new Model(val))
        commit('SET_MODELS_FOLDER', models)
        commit('SET_FOLDER', response.data.data.folders)
      }
      return response.data.data
    })
  },
  createFolder ({ commit, dispatch, state }, form) {
    return api.createModelFolder(form).then((response) => {
      dispatch('selectFolder', {
        reset: true,
        workspaceId: form.workspaceId,
        folderId: form.parentId ? form.parentId : undefined
      })
      return response.data
    })
  },
  afterSelectWorkspace ({ commit, dispatch, rootState }) {
    let workspaceId = rootState.auth.currentWorkspace
    commit('SET_ROUTER', [
      {
        text: 'Root',
        disabled: true,
        id: ''
      }
    ])
    dispatch('fetchModel', workspaceId)
    dispatch('getEnvironment', workspaceId)
    // dispatch('selectFolder', {workspaceId: workspaceId})
  },
  fetchModel ({ commit, state }, workspaceID) {
    return api.getModels(workspaceID).then((response) => {
      const models = response.data.data.map(val => new Model(val))
      let userModels = models.filter(val => !!val.editable)
      commit('SET_MODELS', models)
      commit('SET_USERMODELS', userModels)
      commit('SET_PRE_TRAINED_MODEL', models.filter(val => val.permission == 'public' || val.permission == 'protected'))
      return models
    })
  },
  getEnvironment ({ commit, state }, workspaceID) {
    return api.getENV(workspaceID).then((response) => {
      commit('SET_ENVS', response.data.data)
      return response.data.data
    })
  },
  deleteModels ({ commit, dispatch, state }, form) {
    return api.deleteModel(form).then((response) => {
      dispatch('fetchModel', form.workspaceId)
      return response
    })
  },
  deleteFolder: async ({ commit, dispatch, state }, payload) => {
    await api.deleteModelFolder(payload)
    dispatch('selectFolder', {
      reset: true,
      workspaceId: payload.workspaceId,
      folderId: state.router.find(item => item.disabled) ? state.router.find(item => item.disabled).id : undefined
    })
  },
  moveFolder: async ({ dispatch }, payload) => {
    const res = await api.moveModelFolder(payload)
    dispatch('getMiniFolder', {
      workspaceId: payload.workspaceId
    })
    return res
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/model.js